module.exports = __webpack_public_path__ + "img/MissingSensorData.28cda1e4.svg";